import { Link } from 'react-router-dom';
import type { Drama } from '@/mocks/dramas';

type Props = {
  drama: Drama;
  variant?: 'grid' | 'list';
};

export default function DramaCard({ drama, variant = 'grid' }: Props) {
  if (variant === 'list') {
    return (
      <Link
        to={`/detail/${drama.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
      >
        <div className="h-32 w-24 shrink-0 overflow-hidden rounded-md bg-background-200">
          <img
            src={drama.poster}
            alt={`${drama.title}剧照封面`}
            title={`${drama.title} - 最新电视剧推荐`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <h3 className="clamp-1 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600">
              {drama.title}
            </h3>
            <span className="shrink-0 rounded bg-accent-100 px-1.5 py-0.5 text-xs font-semibold text-accent-800">
              {drama.rating.toFixed(1)}
            </span>
          </div>
          <p className="mt-1 text-xs text-foreground-500">
            {drama.starring.join(' / ')}
          </p>
          <p className="clamp-2 mt-2 text-xs leading-relaxed text-foreground-600">{drama.synopsis}</p>
          <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
            <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">{drama.categoryName}</span>
            <span>{drama.region}</span>
            <span>·</span>
            <span>{drama.year}</span>
            <span>·</span>
            <span className={drama.status === '连载中' ? 'text-accent-700' : 'text-foreground-500'}>
              {drama.status === '连载中' ? `更新至 ${drama.updatedTo} 集` : '已完结'}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={drama.poster}
          alt={`${drama.title}剧照封面`}
          title={`${drama.title} - 最新电视剧推荐`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded bg-primary-950/80 px-2 py-0.5 text-xs font-medium text-background-50">
          {drama.status === '连载中' ? `更新至 ${drama.updatedTo} 集` : '已完结'}
        </span>
        <span className="absolute right-2 top-2 flex h-8 w-12 items-center justify-center rounded bg-accent-500 font-heading text-sm font-bold text-primary-950">
          {drama.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="clamp-1 font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-600">
          {drama.title}
        </h3>
        <p className="clamp-1 mt-1 text-xs text-foreground-500">{drama.starring.join(' / ')}</p>
        <div className="mt-2 flex items-center justify-between text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">{drama.categoryName}</span>
          <span>{drama.updatedAt}</span>
        </div>
      </div>
    </Link>
  );
}